/**
 * This patch fixes corrupt HTML embeds that have compiled in `node.data.embed` instead of `node.data.embed.meta`
 */

import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const isHtmlEmbed = DomTypeUtils.isHtmlEmbed(jsonNode && jsonNode.data);
  const isCorruptHtmlEmbed = isHtmlEmbed && data.embed.compilable;

  return {
    needed: isCorruptHtmlEmbed,
    logData: {
      msg: 'HTML embed has compilable in `node.data.embed`',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.embed.meta = data.embed.meta || {};
      data.embed.meta.compilable = true;
      // eslint-disable-next-line webflow/no-delete
      delete data.embed.compilable;
    },
  };
};
